













































import { ICouponMessage } from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class DialogCoupon extends Vue {
  @Prop(Object) couponMessage!: ICouponMessage;
  @Prop(Boolean) validCoupon!: boolean;
  @Prop(Function) closeDialog!: () => void;
}
